/**
 * @flow
 * @format
 */

import React from 'react';
import { Col } from 'reactstrap';
import _ from 'lodash';
import cc from 'classcat';

import { createHTMLMarkup } from '~/utils';
import Aux from '~/utils/react-aux';
import InputField from '../InputField';

import classes from './FieldStacked.scss';
// import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';
// import debug from '~/utils/macros/debug.macro';

type PropsType = {
  fieldName: string | ReactElementType,
  id: string,
  readOnly: boolean,
  tooltip: string | ReactElementType | ReactElementType[],
  type: string,
  unit: ?string,
  value: [string, string, string][],
};

export class FieldStacked extends React.Component<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  shouldComponentUpdate(nextProps: PropsType) {
    return !_.isEqual(this.props.value, nextProps.value);
  }

  render() {
    // debug(this.props);

    const style = { height: '2rem', display: 'flex' };

    // <div className={fieldWrapperClasses.infoIconWrapper}>
    //   {this.props.tooltip}
    // </div>

    const fieldNames = _.map(this.props.value, (f, i: number) => {
      const stackTip =
        this.props.tooltip &&
        Array.isArray(this.props.tooltip) &&
        this.props.tooltip[i]
          ? this.props.tooltip[i]
          : null;
      return (
        <h5 key={f[0]} style={style}>
          {createHTMLMarkup(f[0])}
          {stackTip}
        </h5>
      );
    });
    const fieldInputs: ReactElementType[] = _.map(this.props.value, f => (
      <InputField
        className={cc([classes.inputGroup])}
        key={f[0]}
        value={f[1]}
        readOnly
        type="text"
        unit={f[2]}
      />
    ));

    return (
      <Aux>
        <Col
          sm={process.env.REACT_APP_LEFT_PANE_SIZE}
          className={classes.subHeader}
        >
          {fieldNames}
        </Col>
        <Col>
          <div className={classes.flexCol}>{fieldInputs}</div>
        </Col>
      </Aux>
    );
  }
}

export default FieldStacked;



// WEBPACK FOOTER //
// ./src/components/FieldStacked/FieldStacked.js